<template lang="pug">
    .container-fluid.recruit
        .row
            .col-12
                .container-swiper
                  .swiper-container
                      .swiper-wrapper
                          .swiper-slide(v-for="(repeater, index) in gallery", v-bind:key="index")
                              img.swiper__img(:src="repeater.src", :alt="repeater.alt")
                              .swiper__caption
                                  | {{repeater.caption}}
                      .swiper__generalText(v-if="header", v-html="header")
                      .swiper-pagination
                  .swiper-button-prev
                  .swiper-button-next

</template>

<script>
    export default {
        name: "WidgetSlider",
        props: {
            gallery: Array,
            header: String,
            duration: Number
        },
        mounted() {
            let swiper = document.createElement("script");
            const autoplay = (this.gallery.length > 1)
                ? { delay: this.duration * 1000, disableOnInteraction: false } : false;
            swiper.onload = function () {
                var mySwiper = new Swiper(".swiper-container", {
                    loop: true,
                    slidesPerView: 1,
                    autoplay,
                    loopAdditionalSlides: 1,
                    pagination: {
                        el: ".swiper-pagination"
                    },
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev"
                    },
                    scrollbar: {
                        el: ".swiper-scrollbar"
                    },
                    width: 680,
                    slidesOffsetBefore: 290,
                    slidesOffsetAfter: 290,
                    breakpoints: {
                      767: {
                        width: undefined,
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0,
                      },
                      1023: {
                        width: 640,
                        slidesOffsetBefore: 25,
                        slidesOffsetAfter: 25,
                      },
                      1599: {
                        width: 686,
                        slidesOffsetBefore: 67,
                        slidesOffsetAfter: 67,
                      },
                    }
                });
            };
            swiper.src = "https://cdnjs.cloudflare.com/ajax/libs/Swiper/4.5.0/js/swiper.min.js";
            document.head.appendChild(swiper);
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../node_modules/swiper/dist/css/swiper.css";
</style>

<style lang="sass" scoped>
    @import "../../node_modules/bootstrap/scss/functions"
    @import "../assets/styles/CustomVariables"
    @import "../assets/styles/wysiwyg"
    @import "../assets/styles/common"
    @import "../../node_modules/bootstrap/scss/variables"
    @import "../../node_modules/bootstrap/scss/mixins"
    @import "../../node_modules/bootstrap/scss/grid"
    .recruit
      margin-top: 2rem
      background: #f8f8f8
    .container-swiper
      @extend .container
      position: relative
      overflow: visible
      max-width: 1290px
      @include media-breakpoint-down(lg)
        max-width: 850px
      @include media-breakpoint-down(md)
        max-width: 690px
        padding-left: 0
        padding-right: 0
      @include media-breakpoint-down(sm)
        max-width: 510px
    .swiper
        &-slide
            img
                width: auto
                height: 515px
                @include media-breakpoint-down(md)
                    width: 100%
                    height: auto

        &-container
          position: relative
          margin: 2rem auto
          &:before,
          &:after
            content: ''
            position: absolute
            top: 0
            z-index: 25
            display: inline-block
            width: 290px
            height: 515px
            background: white
            @include media-breakpoint-down(lg)
              width: 67px
            @include media-breakpoint-down(md)
              width: 25px
            @include media-breakpoint-down(sm)
              display: none
          &:before
            left: 0
            background: linear-gradient(to right, rgba(248,248,248,1) 0%,rgba(255,255,255,0) 100%)
          &:after
            right: 0
            background: linear-gradient(to left, rgba(248,248,248,1) 0%,rgba(255,255,255,0) 100%)
        &__caption
            min-height: 3rem
            box-sizing: content-box
            padding: .5rem 0
            background: #bee4ef
            text-align: center
            font-size: 1rem
            @include media-breakpoint-down(md)
                min-height: 2rem
                padding: .25rem 0
                font-size: .8rem

        &__generalText
            padding: 1rem .5rem
            background: #ececec
            text-align: center
            font-size: 1rem
            @include media-breakpoint-down(md)
                padding: .5rem .5rem
                font-size: .8rem

        &-pagination
            position: relative
            left: auto
            bottom: auto
            padding: 1rem 0
            background: #f8f8f8
            @include media-breakpoint-down(md)
                padding: .5rem 0
</style>

<style lang="sass">
    .swiper-pagination-bullet
        width: .8rem
        height: .8rem
        box-sizing: border-box
        background: #f8f8f8
        border: 2px solid #76cce1
        opacity: 1
        @media (max-width: 1024px)
            width: .6rem
            height: .6rem

        &-active
            background: #76cce1
            border: none

    .swiper-button-next
        right: -5%
        opacity: .8
        @media (max-width: 1024px)
            top: 42%
            right: 15px
            transform: scale(.5)

    .swiper-button-prev
        left: -5%
        opacity: .8
        @media (max-width: 1024px)
            top: 42%
            left: 15px
            transform: scale(.5)

    .swiper-slide-next img, .swiper-slide-prev img
        filter: contrast(50%)
    .swiper-slide:not(.swiper-slide-active)
        .swiper__caption
            color: transparent
</style>
